import { render, staticRenderFns } from "./TenantIpRestrictions.vue?vue&type=template&id=6127aff0"
import script from "./TenantIpRestrictions.vue?vue&type=script&lang=ts"
export * from "./TenantIpRestrictions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports